import { Insurance } from '@/models/appointment/Appointment.ts';
import { PVSProvider } from '@/models/customers/PVSProvider.ts';

export interface Communication {
    is_preferred: boolean;
    value: string;
}

export enum PhoneNumberType {
    MOBILE = 'MOBILE',
    LANDLINE = 'LANDLINE',
}

export interface PhoneNumber extends Communication {
    type: PhoneNumberType;
}

export interface GenericPatientInsurance {
    id?: string;
    name: string;
    type: string;
    location_id?: string;
    card_swipe_date?: string;
}

export interface PatientCostCarrier {
    insurance: Insurance;
    isCardActive: boolean;
}

export interface PatientInfoLine {
    dateOfBirthWithAge: string;
    genderCode: string;
    costCarriers: PatientCostCarrier[];
}

export interface GenericPatient {
    pvs_user_id: string;
    is_registered: boolean;
    // uuid if registered or could be instance_id::pms_user_id
    eterno_user_id?: string;
    instance_id: string;
    patient_number?: string;
    is_data_admission_to_pvs_approved?: boolean;
    pvs_provider: PVSProvider;
    personal: {
        academic_title?: string; // academic title, e.g. "Dr.", "Prof. Dr." (distinct from salutation)
        salutation?: string; // [ "MR", "MS", "NONE" ]
        first_name: string;
        last_name: string;
        date_of_birth: string;
        gender?: string;
    };
    address?: {
        house_number?: string;
        street?: string; // optional for Doc Cirrus
        addon?: string; // Adresszusatz
        city: string;
        zip: string;
        country: string;
        country_code: string; // ISO 3166-1 alpha-2 e.g: 'DE'
    };
    contact: {
        emails: Communication[];
        phone_numbers: PhoneNumber[];
    };
    insurances: GenericPatientInsurance[];
}
